import { useState } from 'react';
import SemestreCursoTab from '../../Tabs/SemestreCursoTab';

const tabsList = [
    { key: 'cursos', label: 'Cursos del Semestre' },
];

export default function SemestresTabs({ semestreId }) {
    const [active, setActive] = useState('cursos');
    const hasValidContext = Number(semestreId || 0) > 0;

    if (!hasValidContext) {
        return (
            <div className="person-tabs-disabled">
                <span>
                    Selecciona o crea un semestre y pulsa <b>Editar</b> para gestionar sus datos relacionados.
                </span>
            </div>
        );
    }

    return (
        <div className="person-tabs-wrap">
            <div className="person-tabs-bar">
                {tabsList.map((t) => (
                    <button
                        key={t.key}
                        className={`person-tab ${active === t.key ? 'is-active' : ''}`}
                        onClick={() => setActive(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="person-tab-panel">
                {active === 'cursos' && <SemestreCursoTab fkValue={semestreId} />}
            </div>
        </div>
    );
}
